import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import ChangePasswordModal from "../pages/admin/ChangePasswordModal";

const AdminHeader = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const [admin, setAdmin] = useState({
    name: "Admin",
    email: "",
    designation: "Administrator",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setAdmin({
        name: decoded.name || "Admin",
        email: decoded.email || "",
        designation: decoded.designation || "Administrator",
      });
    } catch (err) {
      console.error("Invalid token");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/admin");
  };

  const avatarBase = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    admin.name,
  )}&background=0D6EFD&color=fff`;

  return (
    <>
      <header className="admin-header">
        <nav className="app-header navbar navbar-expand bg-body shadow-sm">
          <div className="container-fluid">
            {/* LEFT */}
            <ul className="navbar-nav">
              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link btn btn-link"
                  onClick={toggleSidebar}
                >
                  <i className="bi bi-list fs-4"></i>
                </button>
              </li>
            </ul>

            <div className="flex-grow-1 text-center d-none d-md-block">
              <h2 className="fw-bold mb-0 fs-4 fs-lg-3">
                Financial Support Scheme (FSS)
              </h2>
            </div>

            {/* RIGHT */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle d-flex align-items-center gap-2 btn btn-link"
                  data-bs-toggle="dropdown"
                >
                  <img
                    src={`${avatarBase}&size=40`}
                    alt={admin.name}
                    className="rounded-circle"
                  />
                  <span className="fw-semibold d-none d-md-inline">
                    {admin.name}
                  </span>
                </button>

                <ul className="dropdown-menu dropdown-menu-end shadow p-0">
                  <li className="px-4 py-3 text-center border-bottom">
                    <img
                      src={`${avatarBase}&size=64`}
                      alt={admin.name}
                      className="rounded-circle mb-2"
                    />
                    <div className="fw-semibold">{admin.name}</div>
                    <small className="text-muted">{admin.designation}</small>
                  </li>

                  <li>
                    <button
                      className="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModal"
                    >
                      <i className="bi bi-key me-2"></i>
                      Change Password
                    </button>
                  </li>

                  <li>
                    <hr className="dropdown-divider" />
                  </li>

                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      <i className="bi bi-box-arrow-right me-2"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      {/* 🔥 REQUIRED */}
      <ChangePasswordModal />
    </>
  );
};

export default AdminHeader;
